module.exports = __webpack_public_path__ + "static/media/image2.cd2b8346.png";